import { render, staticRenderFns } from "./UpcomingBox.vue?vue&type=template&id=1a570ffb"
import script from "./UpcomingBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpcomingBox.vue?vue&type=style&index=0&id=1a570ffb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports